import React, { useState, useEffect } from 'react';
import styles from './AppAvatar.module.scss';

const AvatarBadge = ({ role, size }) => {
  const [currentColor, setCurrentColor] = useState('');
  const [transformedRole, setTransformedRole] = useState('');

  const short = () => {
    if (role === 'expert') {
      setCurrentColor('#0ab2ab');
      return 'exp';
    }
    if (role === 'investor') {
      setCurrentColor('#3C7097');
      return 'inv';
    }
    if (role === 'business') {
      setCurrentColor('#2D8342');
      return 'bsn';
    }
    if (role === 'individual') {
      setCurrentColor('#D8913C');
      return 'ind';
    }
    return '';
  };

  useEffect(() => {
    const convertedRole = short();
    setTransformedRole(convertedRole);
  }, [role]);

  return (
    <div
      style={{
        right: `${size === 56 ? '10.5px' : size === 63 ? '16px' : '5.5px'}`,
        color: `${currentColor}`,
      }}
      className={styles.avatarBadge}
    >
      <span>{transformedRole}</span>
    </div>
  );
};

export default AvatarBadge;
